import React from "react";
import { useHistory } from "react-router-dom";
// import { makeStyles } from "@material-ui/core/styles";
import MainLayout from "../layout/MainLayout";
import CancerIntroHeader from "../layout/Header/CancerIntroHeader";
import CancerMainFooter from "../layout/Footer/CancerMainFooter";
import ImgList from "./ImgList";
// import Grid from "@material-ui/core/Grid";
// import Typography from "@material-ui/core/Typography";
// import Button from "@material-ui/core/Button";
// import clsx from "clsx";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     // height: "100vh",
//     width: "100%",
//   },
//   header: {
//     color: "#10459a",
//     marginTop: theme.spacing(11),
//     [theme.breakpoints.down("sm")]: {
//       marginTop: theme.spacing(5),
//     },
//   },
//   cancerImg: {
//     width: 180,
//     height: 180,
//     marginBottom: 33,
//     [theme.breakpoints.down("md")]: {
//       width: 160,
//       height: 160,
//       marginBottom: 20,
//     },
//     [theme.breakpoints.down("sm")]: {
//       width: 90,
//       height: 90,
//     },
//   },
//   lungImg1: {
//     backgroundImage: "url(/images/prostate/section_illust_01_prostate.png)",
//     backgroundRepeat: "no-repeat",
//     backgroundPosition: "center center",
//     backgroundSize: "cover",
//     width: "100%",
//     height: "100%",
//     margin: "0 auto",
//   },
//   lungImg2: {
//     backgroundImage: "url(/images/prostate/section_illust_02_prostate.png)",
//     backgroundRepeat: "no-repeat",
//     backgroundPosition: "center center",
//     backgroundSize: "cover",
//     width: "100%",
//     height: "100%",
//     margin: "0 auto",
//   },
//   lungImg3: {
//     backgroundImage: "url(/images/prostate/section_illust_03_prostate.png)",
//     backgroundRepeat: "no-repeat",
//     backgroundPosition: "center center",
//     backgroundSize: "cover",
//     width: "100%",
//     height: "100%",
//     margin: "0 auto",
//   },

//   regular: {
//     color: "#1a2633",
//     fontWeight: 400,
//   },
//   regular2: {
//     fontWeight: 400,
//   },
//   bold: {
//     fontWeight: 500,
//   },
//   body: {
//     // marginTop: 40,
//     // height: 500,
//     marginBottom: 27.91,
//     [theme.breakpoints.down("sm")]: {
//       marginBottom: "auto",
//     },
//   },
//   selectList: {
//     flexWrap: "wrap",
//     width: 1000,
//     marginTop: 90,
//     marginBottom: 172,
//     [theme.breakpoints.down("md")]: {
//       width: "90%",
//       height: "auto",
//       marginTop: 100,
//       marginBottom: 103,
//       justifyContent: "space-evenly",
//     },
//     [theme.breakpoints.down("sm")]: {
//       marginTop: theme.spacing(5),
//       width: "100%",
//       marginBottom: "auto",
//     },
//   },
//   onImg: {
//     borderRadius: "50%",
//   },
//   footer: {
//     width: "100%",
//     textAlign: "center",
//     [theme.breakpoints.down("sm")]: {
//       position: "absolute",
//       bottom: theme.spacing(2),
//     },
//   },
//   button: {
//     width: 432,
//     height: 78,
//     fontSize: 20,
//     [theme.breakpoints.down("sm")]: {
//       width: 300,
//       height: 56,
//       fontSize: 18,
//     },
//   },
//   item: {
//     cursor: "pointer",
//   },
//   marginTp: {
//     marginTop: theme.spacing(3),
//     [theme.breakpoints.down("sm")]: {
//       marginTop: theme.spacing(1.5),
//     },
//   },
//   tems: {
//     [theme.breakpoints.down("md")]: {
//       marginBottom: 52,
//       width: "33%",
//     },
//     [theme.breakpoints.down("sm")]: {
//       marginBottom: theme.spacing(5),
//       minHeight: 140,
//     },
//   },
//   large: {
//     [theme.breakpoints.down("sm")]: {
//       display: "none",
//     },
//   },
//   small: {
//     display: "none",
//     [theme.breakpoints.down("sm")]: {
//       display: "block",
//     },
//   },
// }));

const LungCancerMain = () => {
  // const classes = useStyles();
  const history = useHistory();
  // const [view, setView] = useState(1);
  const handleLink = (link) => {
    history.push(`/prostatecancer/calculate`);
  };
  // const handleChange = (num = 1) => {
  //   setView(num);
  // };
  return (
    <MainLayout
      header={<CancerIntroHeader cancer="전립선암" />}
      footer={<CancerMainFooter onClick1={handleLink} />}
    >
      <ImgList />
    </MainLayout>
    // <Grid container direction="column" className={classes.root}>
    //   <Grid
    //     container
    //     justify="center"
    //     direction="column"
    //     alignItems="center"
    //     className={classes.header}
    //   >
    //     <Typography variant="h2">
    //       <span className={classes.regular}>
    //         전립선암 조기검진을 받아야 할까요?
    //       </span>
    //     </Typography>
    //     <Typography
    //       variant="h4"
    //       color="textSecondary"
    //       align="center"
    //       className={classes.marginTp}
    //     >
    //       <span className={classes.regular2}>
    //         아래와 같은 순서대로 살펴보겠습니다.
    //       </span>
    //     </Typography>
    //   </Grid>
    //   <Grid
    //     container
    //     justify="center"
    //     alignItems="center"
    //     className={classes.body}
    //   >
    //     <Grid
    //       container
    //       alignItems="center"
    //       justify="space-between"
    //       className={classes.selectList}
    //     >
    //       <Grid className={classes.tems}>
    //         <Grid
    //           container
    //           justify="center"
    //           direction="column"
    //           alignItems="center"
    //         >
    //           <div className={classes.cancerImg}>
    //             <div className={clsx(classes.lungImg1)}></div>
    //           </div>
    //           <Typography variant="h6" align="center">
    //             <span className={classes.regular}>전립선암이란?</span>
    //           </Typography>
    //         </Grid>
    //       </Grid>
    //       <Grid className={classes.tems}>
    //         <Grid
    //           container
    //           justify="center"
    //           direction="column"
    //           alignItems="center"
    //         >
    //           <div className={classes.cancerImg}>
    //             <div className={clsx(classes.lungImg2)}></div>
    //           </div>
    //           <Typography variant="h6" align="center">
    //             <span className={clsx(classes.regular, classes.large)}>
    //               전립선암 검진은 무엇인가요?
    //             </span>
    //             <span className={clsx(classes.regular, classes.small)}>
    //               전립선암 검진은
    //               <br />
    //               무엇인가요?
    //             </span>
    //           </Typography>
    //         </Grid>
    //       </Grid>
    //       <Grid className={classes.tems}>
    //         <Grid
    //           container
    //           justify="center"
    //           direction="column"
    //           alignItems="center"
    //         >
    //           <div className={classes.cancerImg}>
    //             <div className={clsx(classes.lungImg3)}></div>
    //           </div>
    //           <Typography variant="h6" align="center">
    //             <span className={clsx(classes.regular, classes.large)}>
    //               전립선암 검진의 이득과 위험
    //             </span>
    //             <span className={clsx(classes.regular, classes.small)}>
    //               전립선암 검진의
    //               <br />
    //               이득과 위험
    //             </span>
    //           </Typography>
    //         </Grid>
    //       </Grid>
    //     </Grid>
    //   </Grid>
    //   <Grid className={classes.footer}>
    //     <Button
    //       onClick={handleLink}
    //       variant="contained"
    //       color="primary"
    //       className={classes.button}
    //     >
    //       다음으로
    //     </Button>
    //   </Grid>
    // </Grid>
  );
};

export default LungCancerMain;
